export default {
      id: "book-usage",
      viewBox: "0 0 24 24",
      url: "/dist/svg/" + "sprite.svg#book-usage",
      toString: function () {
        return this.url;
      }
    }